import { useContext, useEffect, useState, useRef } from 'react';

import { EntradasContext } from './context/EntradasContext';

import { db } from './firebase';

import { collection, getDocs, query, orderBy, limit, where, addDoc,serverTimestamp  } from "firebase/firestore";
import MainMenuGrid from './components/MainMenu/MainMenuGrid';

import { hasAccess } from './lib/modules';

import ProductsView from './components/Products/ProductsView';

import IncomingView from './components/Inventory/IncomingView';

import OutgoingView from './components/Inventory/OutgoingView';

import InventoryView from './components/Inventory/InventoryView';

import SalesReportView from './components/Reports/SalesReportView';

import POSView from './components/POS/POSView';

import ExpensesView from './components/Expenses/ExpensesView';

import PayrollView from './components/Payroll/PayrollView';

import UserManagementView from './components/Users/UserManagementView';

import CustomerManagementView from './components/Customers/CustomerManagementView';

import AuditLogView from './components/Audit/AuditLogView';

import FinancialPanel from './components/FinancialPanel/FinancialPanel';

import GlobalSettingsView from './components/Settings/GlobalSettingsView';

import SupplierManagementView from './components/Suppliers/SupplierManagementView';

import CashRegisterCloseView from './components/CashRegister/CashRegisterCloseView';

import LoginView from './components/Auth/LoginView';

import AppHeader from './components/Layout/AppHeader';
import WaiterOrderView from './components/Waiter/WaiterOrderView';
import KitchenView from './components/Kitchen/KitchenView';
import { EntradasProvider } from './context/EntradasContext';
import { SettingsProvider } from './context/SettingsContext';
import { ProductsProvider, useProducts } from './context/ProductsContext';
import { OfflineSyncProvider } from './context/OfflineSyncContext';
import { useSettings } from './context/SettingsContext';
import SkeletonLoaderEntradas from './components/Loading/SkeletonLoaderEntradas';
// arriba con el resto de imports

import CashDrawerAdminView from "./components/Cash/CashDrawerAdminView";

import { onAuthStateChanged, signOut } from "firebase/auth";
import { countPendingOfflineSales } from './lib/offlineSalesQueue';
import { getOpenCashStatus } from './lib/cashApi';

import { auth, authPersistenceReady } from "./firebase";

import { makeEmptyPermissions, makeFullPermissions, normalizePermissionsMatrix } from './lib/modules';

import { ToastContainer, toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

import { doc, getDocFromCache, getDocFromServer, getDocsFromServer } from "firebase/firestore";
import GlobalAnnouncementView from './components/Announcements/GlobalAnnouncementView';
import GlobalAnnouncementBanner from './components/Announcements/GlobalAnnouncementBanner';
import PrintStationRelay from './components/Printing/PrintStationRelay';





// --- Helpers de fecha/hora de corte ---

const CUTOFF_HOUR = 5; // hora de corte

const PROTECTED_EMAIL = 'programacionsebastian94@gmail.com';



// YYYY-MM-DD en hora LOCAL (no UTC)

const localYMD = (d = new Date()) =>

  new Date(d.getTime() - d.getTimezoneOffset() * 60000)

    .toISOString()

    .slice(0, 10);



// âHoyâ en hora local

const todayYMD = () => localYMD();



// ===== NormalizaciÃ³n de permisos por rol (plantillas mÃ­nimas) =====

const baseByRole = (role = '') => {

  // Plantillas rÃ¡pidas por rol. Puedes ampliar/ajustar cuando quieras.

  switch ((role || '').trim()) {

    case 'TI': {
      const full = makeFullPermissions();
      full['Avisos Globales'] = { Lectura: false, Edición: false, Eliminación: false };
      return full;
    }

    case 'Administrador': {
      const full = makeFullPermissions();
      full['Avisos Globales'] = { Lectura: false, Edición: false, Eliminación: false };
      return full;
    }



    case 'Supervisor': {

      const p = makeEmptyPermissions();

      const supervisorModules = [

        'Punto de Venta',

        'Productos',

        'Inventarios',

        'Entradas',

        'Salidas',

        'Reportes',

        'Detalle de Venta',

        'Clientes',

        'Auditoría',

        'Panel Financiero',

        'Cierre de Turno',

        'Toma de Pedidos',

        'Panel de Despacho',

        'Proveedores',

      ];

      supervisorModules.forEach((moduleName) => {

        p[moduleName] = { Lectura: true, Edición: true, Eliminación: false };

      });

      // Bloqueos tipicos

      p['Usuarios'] = { Lectura: false, Edición: false, Eliminación: false };

      p['Configuración'] = { Lectura: false, Edición: false, Eliminación: false };

      p['Turnos de Caja (Admin)'] = { Lectura: false, Edición: false, Eliminación: false };

      // Ajustes finos

      p['Nómina'] = { Lectura: true, Edición: false, Eliminación: false };

      p['Panel de Despacho'] = { Lectura: true, Edición: false, Eliminación: false };

      return p;

    }



    case 'Cajero': {

      const p = makeEmptyPermissions();

      const cashierModules = [

        'Punto de Venta',

        'Productos',

        'Inventarios',

        'Entradas',

        'Salidas',

        'Detalle de Venta',

        'Clientes',

        'Cierre de Turno',

      ];

      cashierModules.forEach((moduleName) => {

        const editable = moduleName === 'Punto de Venta' || moduleName === 'Cierre de Turno';

        p[moduleName] = { Lectura: true, Edición: editable, Eliminación: false };

      });

      return p;

    }

    case 'Mesero': {

      const p = makeEmptyPermissions();

      const waiterModules = [

        'Toma de Pedidos',

        'Panel de Despacho',

        'Clientes',

      ];

      waiterModules.forEach((moduleName) => {

        const editable = moduleName === 'Toma de Pedidos';

        p[moduleName] = { Lectura: true, Edición: editable, Eliminación: false };

      });

      return p;

    }



    default:

      // Rol desconocido â nada habilitado (seguro por defecto)

      return makeEmptyPermissions();

  }

};



// Mezcla plantilla por rol + permisos que vengan del doc (si existen)

const normalizeUserPerms = (u) => {

  const base = baseByRole(u?.role);

  return { ...u, permissions: { ...base, ...normalizePermissionsMatrix(u?.permissions || {}) } };

};

const buildSessionUser = (firebaseUser, userDoc = {}) => {
  const safeUser = normalizeUserPerms({
    uid: firebaseUser.uid,
    email: firebaseUser.email,
    username: userDoc.displayName || userDoc.username || firebaseUser.email,
    role: userDoc.role || 'Cajero',
    permissions: userDoc.permissions || {},
    isActive: userDoc.isActive !== false,
    storeId: userDoc.storeId || userDoc.sedeId || null,
  });

  const isProtectedUser =
    (firebaseUser.email || '').trim().toLowerCase() === PROTECTED_EMAIL;

  if (!isProtectedUser) return safeUser;

  return {
    ...safeUser,
    permissions: makeFullPermissions(),
  };
};





// Â¿ya pasÃ³ la hora de corte?

const isAfterCutoff = (h = CUTOFF_HOUR) => new Date().getHours() >= h;

// Log de tamaño de snapshots para identificar consultas costosas
const logSnapSize = (label, snap) => {
  try {
    console.log(`[FS] ${label} docs: ${snap?.size ?? 'n/a'}`);
  } catch (_) {
    console.log(`[FS] ${label} (no size disponible)`);
  }
};





const AppInner = ({ loggedInUser, authError, clearAuthError }) => {

 const [currentView, setCurrentView] = useState('login');
 const [activeCashRegister, setActiveCashRegister] = useState(null);
 const [ventasFirestore, setVentasFirestore] = useState([]);
 const [expensesData, setExpensesData] = useState([]);
 const [incomingData, setIncomingData] = useState([]);
const [turnoModal, setTurnoModal] = useState({ open: false, fecha: '' });
const viewRef = useRef('login');

useEffect(() => {
  if (loggedInUser) {
    setCurrentView((previousView) =>
      previousView === 'login' ? 'mainMenu' : previousView
    );
    return;
  }

  setCurrentView('login');
  setActiveCashRegister(null);
}, [loggedInUser]);
  const viewsNeedingProducts = new Set([
    'pos',
    'products',
    'inventory',
    'incoming',
    'outgoing',
    'reports',      // reportes necesita catálogo para calcular costos/utilidad
    'financialPanel', // panel financiero necesita catálogo completo para COGS/recetas
    'waiter',       // toma de pedidos: necesita catálogo y cache incremental
    'kitchen',
  ]);
 const shouldSubscribeProducts = !!loggedInUser && viewsNeedingProducts.has(currentView);
const { products, setProducts, refreshProducts, subscribeToProductChanges, loadAllProductsOnce, loadingAll, fullReady } = useProducts();
const { settings } = useSettings();
useEffect(() => { viewRef.current = currentView; }, [currentView]);

// 👉 Cargar productos SOLO cuando entro a una vista que los necesita
useEffect(() => {
  if (!shouldSubscribeProducts) return;
  let cancelled = false;
  let unsubscribeChanges = () => {};

  const startProductSync = async () => {
    unsubscribeChanges = subscribeToProductChanges();
    await refreshProducts();
    if (['kitchen', 'incoming', 'outgoing'].includes(currentView)) {
      await loadAllProductsOnce();
    }
    if (cancelled) unsubscribeChanges();
  };

  startProductSync();
  return () => {
    cancelled = true;
    unsubscribeChanges();
  };
}, [shouldSubscribeProducts, currentView, refreshProducts, subscribeToProductChanges, loadAllProductsOnce]);



// Botón físico "Atrás" en móviles: si estás en un módulo, regresa al menú

useEffect(() => {

  if (typeof window === 'undefined') return;



  const handleBack = () => {

    if (viewRef.current && viewRef.current !== 'login' && viewRef.current !== 'mainMenu') {

      setCurrentView('mainMenu');

      window.history.pushState({ view: 'mainMenu' }, '', '#main');

    }

  };



  window.history.pushState({ view: 'init' }, '', '#root');

  window.addEventListener('popstate', handleBack);

  return () => window.removeEventListener('popstate', handleBack);

}, []);



// Cada ingreso a un módulo crea una entrada en el historial para capturar el back

useEffect(() => {

  if (typeof window === 'undefined') return;

  if (currentView && currentView !== 'login' && currentView !== 'mainMenu') {

    window.history.pushState({ view: currentView }, '', `#${currentView}`);

  }

}, [currentView]);



// SuscripciÃ³n a gastos en vivo (colecciÃ³n 'gastos')


                 // â¬ï¸ vuelve a suscribirse tras login



useEffect(() => {

  if (currentView !== 'closeCashRegister' && currentView !== 'financialPanel') return;

  if (!loggedInUser) return;



  const fetchActiveRegister = async () => {

    // 1) Traer la ÃLTIMA caja ABIERTA por openedAt

    let snap = await getDocs(query(

      collection(db, "cajas"),

      where("user", "==", loggedInUser.username),

      where("estado", "==", "abierta"),

      orderBy("openedAt", "desc"),

      limit(1)

    ));
    logSnapSize('cajas abiertas (openedAt)', snap);



    if (snap.empty) {

      // 2) Fallback para docs viejos sin openedAt: elegir la mÃ¡s reciente por fecha/hora

      snap = await getDocs(query(

        collection(db, "cajas"),

        where("user", "==", loggedInUser.username),

        where("estado", "==", "abierta")

      ));
      logSnapSize('cajas abiertas (fallback sin openedAt)', snap);



      if (snap.empty) {

        setActiveCashRegister(null);

        return;

      }



      const pick = snap.docs.reduce((acc, d) => {

        const x = d.data();

        const base = x.date || x.fecha;

        const t = x.time || x.hora;

        const when = base && t ? new Date(`${base}T${t}`) : new Date(0);

        return !acc || when > acc.when ? { d, when } : acc;

      }, null).d;



      const data2 = pick.data();

      setActiveCashRegister({

        id: pick.id,

        ...data2,

        amount: data2.amount ?? data2.montoApertura,

        date: data2.date || data2.fecha,

        time: data2.time || data2.hora,

        status: data2.status || data2.estado,

        openedAt: data2.openedAt || null

      });

      return;

    }



    const doc0 = snap.docs[0];

    const data = doc0.data();

    setActiveCashRegister({

      id: doc0.id,

      ...data,

      amount: data.amount ?? data.montoApertura,

      date: data.date || data.fecha,

      time: data.time || data.hora,

      status: data.status || data.estado,

      openedAt: data.openedAt || null

    });

  };



  fetchActiveRegister();

}, [loggedInUser, currentView]);



const { cargarEntradas, loadingEntradas } = useContext(EntradasContext);



const handleLoadEntradasYMostrar = async () => {

  setCurrentView('incoming'); // Mostrar vista y skeleton de inmediato

  try {

    await cargarEntradas(1);   // Una sola carga, justo cuando se abre el modulo

  } catch (error) {

    console.error("? Error al cargar entradas:", error);

    alert("Error al cargar entradas. Revisa tu conexi?n.");

  }

};



  // Mock de datos para el panel financiero y cierre de caja

  const salesData = [

    { id: 1, date: '2023-05-01T10:00:00', total: 150.00, products: [{name: 'Cerveza', qty: 10, price: 15.00, costPrice: 10.00}], paymentMethod: 'Efectivo', status: 'Completada' },

    { id: 2, date: '2023-05-01T10:30:00', total: 200.50, products: [{name: 'Refresco', qty: 5, price: 40.10, costPrice: 25.00}], paymentMethod: 'Tarjeta', status: 'Completada' },

    { id: 3, date: '2023-05-02T11:00:00', total: 75.20, products: [{name: 'Papas', qty: 3, price: 25.07, costPrice: 15.00}], paymentMethod: 'Nequi', status: 'Completada' },

    { id: 4, date: '2023-05-02T11:30:00', total: 300.00, products: [{name: 'JabÃ³n', qty: 2, price: 150.00, costPrice: 100.00}], paymentMethod: 'Efectivo', status: 'Completada' },

  ];



  // incomingData ahora se alimenta con onSnapshot('entradas')



  const outgoingData = [

    { id: 1, registrationDate: '2023-05-01', productName: 'Cerveza', quantity: 1, reason: 'Merma', date: '2023-05-01T10:10:00', productId: 1 },

    { id: 2, registrationDate: '2023-05-02', productName: 'Papas', quantity: 2, reason: 'Uso Interno', date: '2023-05-02T11:15:00', productId: 3 },

  ];



  // Gastos ahora provienen de Firestore (ver estado y suscripciÃ³n mÃ¡s abajo)



  // Estados para la gestiÃ³n de caja en App.js

  const [cashRegisters, setCashRegisters] = useState([]);

  const [showCashRegisterModal, setShowCashRegisterModal] = useState(false);

  const [cashRegisterStatus, setCashRegisterStatus] = useState({ isOpen: false, currentAmount: 0, existingRegister: null });



  // Estados para el flujo Mesero-Cocina-Cajero

  const [pendingOrders, setPendingOrders] = useState([]); // Pedidos en preparaciÃ³n o listos para cobro



// HORA DE CORTE configurable arriba con CUTOFF_HOUR

const handleOpenPOS = async () => {
  const hoy = todayYMD();
  let abierta = null;

  try {
    // Fuente autoritativa: el mismo backend que abre/cierra la caja.
    // Evita que un snapshot viejo del cache del navegador haga creer
    // que sigue abierta una caja que ya fue cerrada.
    abierta = await getOpenCashStatus();
  } catch (apiError) {
    console.warn('⚠️ No se pudo validar la caja por API. Usando fallback de Firestore.', apiError);

    const readQuery = (typeof navigator !== 'undefined' && navigator.onLine === false)
      ? getDocs
      : getDocsFromServer;

    try {
      const q = query(
        collection(db, "cajas"),
        where("user", "==", loggedInUser.username),
        where("estado", "==", "abierta"),
        orderBy("openedAt", "desc"),
        limit(1)
      );
      const snap = await readQuery(q);
      logSnapSize('POS caja abierta (fallback ordenado)', snap);
      abierta = snap.empty ? null : { id: snap.docs[0].id, ...snap.docs[0].data() };
    } catch (e) {
      console.warn("⚠️ Fallback ordenado no disponible. Usando consulta simple.", e);
      const q2 = query(
        collection(db, "cajas"),
        where("user", "==", loggedInUser.username),
        where("estado", "==", "abierta")
      );
      const s2 = await readQuery(q2);
      logSnapSize('POS caja abierta (fallback simple)', s2);
      abierta = s2.empty ? null : { id: s2.docs[0].id, ...s2.docs[0].data() };
    }
  }

  if (abierta) {
    const fechaTurno =
      abierta.fecha ||
      abierta.date ||
      (abierta.openedAt?.toDate ? localYMD(abierta.openedAt.toDate()) : hoy);

    setActiveCashRegister({ id: abierta.id, ...abierta });

    // Mostrar modal SOLO si el servidor confirma que realmente sigue abierta
    // una caja de un día anterior y ya pasó la hora de corte.
    if (fechaTurno < hoy && isAfterCutoff()) {
      setTurnoModal({ open: true, fecha: fechaTurno });
      return;
    }

    setTurnoModal({ open: false, fecha: '' });
    loadAllProductsOnce();
    setCurrentView('pos');
    return;
  }

  // No existe caja abierta: limpiar cualquier estado viejo que haya quedado
  // en React y entrar al POS para mostrar el modal normal de apertura.
  setActiveCashRegister(null);
  setTurnoModal({ open: false, fecha: '' });
  loadAllProductsOnce();
  setCurrentView('pos');
};

const handleConfirmOpenCashRegister = async (amount) => {

const today = todayYMD(); // fecha local

  const now = new Date().toLocaleTimeString();



  const newRegister = {

    fecha: today,

    hora: now,

    montoApertura: Number(amount),

user: loggedInUser.username, // si tus consultas usan username

estado: 'abierta',

    openedAt: serverTimestamp(),

  };



  const ref = await addDoc(collection(db, "cajas"), newRegister);

  setActiveCashRegister({ id: ref.id, ...newRegister }); // ð usa el id real

  setCurrentView('pos');

};



  const handleCancelCashRegister = () => {

    setShowCashRegisterModal(false);

    setCurrentView('mainMenu');

  };



  const handleSendOrderToKitchen = (order) => {

    setPendingOrders(prev => [...prev, order]);

    console.log("Ticket de Cocina Impreso:", order);

  };



  const handleOrderReadyForPayment = (orderId) => {

    setPendingOrders(prev => prev.map(order => 

      order.id === orderId ? { ...order, status: 'Listo para Cobro' } : order

    ));

  };



  const handleOrderProcessed = (orderId) => {

    setPendingOrders(prev => prev.map(order => 

      order.id === orderId ? { ...order, status: 'Cobrado' } : order

    ));

  };



const handleLogout = async () => {

  const isOffline = typeof navigator !== 'undefined' && navigator.onLine === false;
  if (isOffline) {
    toast.info('Recupera la conexión a Internet para cerrar sesión. Tu sesión permanece activa.');
    return;
  }

  try {

    const pendingOfflineSales = await countPendingOfflineSales();
    if (pendingOfflineSales > 0) {
      toast.warn(`No puedes cerrar sesión: hay ${pendingOfflineSales} venta${pendingOfflineSales === 1 ? '' : 's'} offline pendiente${pendingOfflineSales === 1 ? '' : 's'} de sincronizar.`);
      return;
    }

    await signOut(auth);

  } catch (error) {
    console.error('logout:', error);
    toast.error('No fue posible cerrar sesión. Revisa la conexión e intenta nuevamente.');
  }

};





const renderView = () => {

  if (currentView === 'login') {

    return (
      <LoginView
        externalError={authError}
        onClearExternalError={clearAuthError}
      />
    );

  }



  return (





      

      <div className="font-sans antialiased bg-gray-50 dark:bg-gray-800 min-h-screen transition-colors duration-300 pt-0 sm:pt-4 md:pt-6">

        <PrintStationRelay currentUser={loggedInUser} />
        <AppHeader onLogout={handleLogout} />
        <GlobalAnnouncementBanner settings={settings} />

        {turnoModal.open && (

  <div className="fixed inset-0 z-[999] bg-black/40 flex items-center justify-center p-4">

    <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl">

      <div className="p-5">

        <div className="flex items-start gap-3">

          <div className="shrink-0 mt-1">

            <svg className="w-6 h-6 text-amber-500" viewBox="0 0 24 24" fill="currentColor">

              <path d="M12 2a10 10 0 1010 10A10.011 10.011 0 0012 2zm1 15h-2v-2h2zm0-4h-2V7h2z"/>

            </svg>

          </div>

          <div>

            <h3 className="text-lg font-semibold text-gray-900">Turno abierto sin cerrar</h3>

            <p className="mt-2 text-gray-700">

              Tienes un turno abierto del <b>{turnoModal.fecha}</b> que no fue cerrado.

            </p>

            <p className="mt-1 text-sm text-gray-600">Â¿Quieres ir a cerrarlo ahora?</p>

          </div>

        </div>



        <div className="mt-6 flex gap-3 justify-end">

          <button

            onClick={() => {

              setTurnoModal({ open: false, fecha: '' });

              setCurrentView('pos');           // Continuar en POS

            }}

            className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50"

          >

            Continuar en POS

          </button>

          <button

            onClick={() => {

              setTurnoModal({ open: false, fecha: '' });

              setCurrentView('closeCashRegister'); // Ir a Cierre

            }}

            className="px-4 py-2 rounded-lg bg-emerald-600 text-white hover:bg-emerald-700"

          >

            Ir a cierre

          </button>

        </div>

      </div>

    </div>

  </div>

)}



        {(() => {

          switch(currentView) {

case 'mainMenu':

  return (

    <MainMenuGrid

    currentUser={loggedInUser}

     onLogout={handleLogout} 

      onSelectView={(view) => {

const safeUser = normalizeUserPerms(loggedInUser);

if (!hasAccess(safeUser, view, 'Lectura')) 

  {

           alert('No tienes permisos para esta secciÃ³n.');

       return;

      }

        if (view === 'incoming') {

          handleLoadEntradasYMostrar();

        } else if (view === 'pos') {

          handleOpenPOS();        // ð aquÃ­ usamos la lÃ³gica de caja abierta / corte

        } else {

          setCurrentView(view);

        }

      }}

    />

  );

case 'pos':

return (

  <POSView

     currentUser={loggedInUser}   

          products={products}
      loadingAll={loadingAll}
      fullReady={fullReady}

      pendingOrders={pendingOrders}

      onOrderProcessed={handleOrderProcessed}

      onBack={() => setCurrentView('mainMenu')}

      currentCashRegister={activeCashRegister}  

    />

  );

case 'cashDrawers':

 return (

  <CashDrawerAdminView

    currentUser={loggedInUser}            // â lo necesita para âupdatedByâ

    onBack={() => setCurrentView('mainMenu')}

   />

 );

            case 'waiter':

 return (

   <WaiterOrderView

    currentUser={loggedInUser}            // â asÃ­ tendrÃ¡ uid/email

    products={products}

     onSendToKitchen={handleSendOrderToKitchen}

    onReadyForPayment={handleOrderReadyForPayment}

     onBack={() => setCurrentView('mainMenu')}

   />

 );     

// App.js â en el switch de vistas

case 'kitchen':

  return (

    <KitchenView

      currentUser={loggedInUser}             // ð PASAR EL USUARIO

      kitchenOrders={pendingOrders}

      products={products}

      productsReady={fullReady}

      onOrderReady={handleOrderReadyForPayment}

      onBack={() => setCurrentView('mainMenu')}

    />

  );

            case 'products':

             return <ProductsView currentUser={loggedInUser} products={products} setProducts={setProducts} onBack={() => setCurrentView('mainMenu')} />;

            case 'incoming':

            return <IncomingView currentUser={loggedInUser} products={products} setProducts={setProducts} onBack={() => setCurrentView('mainMenu')} />;

            case 'outgoing':

            return <OutgoingView currentUser={loggedInUser} products={products} onBack={() => setCurrentView('mainMenu')} />;

            case 'inventory':

            return <InventoryView currentUser={loggedInUser} products={products} setProducts={setProducts} onBack={() => setCurrentView('mainMenu')} />;

            case 'reports':

              return <SalesReportView currentUser={loggedInUser} onBack={() => setCurrentView('mainMenu')} />;

            case 'expenses':

            return <ExpensesView currentUser={loggedInUser} onBack={() => setCurrentView('mainMenu')} />;

            case 'salesDetail':

              // Redirigido a Reportes -> Detalle por Producto

              return <SalesReportView currentUser={loggedInUser} onBack={() => setCurrentView('mainMenu')} initialSubView="detail" />;

            case 'payroll':

              return <PayrollView onBack={() => setCurrentView('mainMenu')} currentUser={loggedInUser} />;

            case 'users':

            return <UserManagementView currentUser={loggedInUser} onBack={() => setCurrentView('mainMenu')} />;

case 'customers':

 return <CustomerManagementView currentUser={loggedInUser} onBack={() => setCurrentView('mainMenu')} />;        

     case 'audit':

              return <AuditLogView onBack={() => setCurrentView('mainMenu')} />;

case 'financialPanel':

  return (

    <FinancialPanel

      onBack={() => setCurrentView('mainMenu')}

      incomingData={incomingData}          // si ya tienes entradas reales, pÃ¡salas aquÃ­

      expensesData={expensesData}          // idem gastos reales si ya existen

      productsData={products}              // catálogo real (con costPrice)
      productsLoading={loadingAll}
      productsFullReady={fullReady}

 outgoingData={outgoingData}

     />

  );

            case 'settings':

              return <GlobalSettingsView onBack={() => setCurrentView('mainMenu')} />;

            case 'globalNotice':

              return <GlobalAnnouncementView currentUser={loggedInUser} onBack={() => setCurrentView('mainMenu')} />;

            case 'suppliers':

              return <SupplierManagementView onBack={() => setCurrentView('mainMenu')} />;

            case 'closeCashRegister':

              const today = new Date().toISOString().split('T')[0];

return <CashRegisterCloseView

  onBack={() => setCurrentView('mainMenu')}

 currentUser={loggedInUser}

   currentCashRegister={activeCashRegister}

  salesData={ventasFirestore}  // <-- aquí sí usas ventasFirestore (ventas reales)

  incomingData={incomingData}   // luego puedes hacer igual con ingresos/salidas reales si quieres

  outgoingData={outgoingData}

  products={products}

/>;

            default:

              return <MainMenuGrid 

              onSelectView={setCurrentView}

 currentUser={loggedInUser}   // ð corregido

      onLogout={handleLogout}  

                        />;

              

          }

        })()}

      </div>

    );

  };



  return renderView();



  

 };



<ToastContainer

  position="top-center"

  autoClose={2200}

  hideProgressBar={false}

  newestOnTop

  closeOnClick

  pauseOnFocusLoss

  draggable

  pauseOnHover

  theme="colored"

/>





export default function App() {

  const [loggedInUser, setLoggedInUser] = useState(null);
  const [authInitializing, setAuthInitializing] = useState(true);
  const [authError, setAuthError] = useState('');

  useEffect(() => {
    let cancelled = false;
    let unsubscribe = () => {};
    let serverValidation = null;

    const isCurrentAuthUser = (firebaseUser) =>
      !cancelled && auth.currentUser?.uid === firebaseUser.uid;

    const rejectSession = async (message) => {
      if (cancelled) return;

      setAuthError(message);
      setLoggedInUser(null);

      try {
        await signOut(auth);
      } catch (error) {
        console.warn('No se pudo limpiar la sesión local', error);
      }

      if (!cancelled) setAuthInitializing(false);
    };

    const applyProfile = (firebaseUser, profile) => {
      if (!isCurrentAuthUser(firebaseUser)) return false;

      setLoggedInUser(buildSessionUser(firebaseUser, profile));
      setAuthError('');
      return true;
    };

    const validateFromServer = (firebaseUser, { required = false } = {}) => {
      if (serverValidation?.uid === firebaseUser.uid) {
        return serverValidation.promise;
      }

      const promise = (async () => {
        try {
          const snapshot = await getDocFromServer(doc(db, 'users', firebaseUser.uid));
          if (!isCurrentAuthUser(firebaseUser)) return false;

          if (!snapshot.exists()) {
            await rejectSession(
              'Tu cuenta no está configurada en ValenPOS. Contacta al administrador.'
            );
            return false;
          }

          const profile = snapshot.data();
          if (profile?.isActive === false) {
            await rejectSession(
              'Tu usuario está desactivado. Consulta con el administrador.'
            );
            return false;
          }

          const accepted = applyProfile(firebaseUser, profile);
          if (accepted && !cancelled) setAuthInitializing(false);
          return accepted;
        } catch (error) {
          if (!isCurrentAuthUser(firebaseUser)) return false;

          const isOffline =
            (typeof navigator !== 'undefined' && navigator.onLine === false) ||
            error?.code === 'unavailable';

          if (required) {
            await rejectSession(
              isOffline
                ? 'No hay conexión y este dispositivo aún no tiene un perfil autorizado guardado. Conéctate a Internet para ingresar por primera vez.'
                : 'No fue posible validar tu perfil. Revisa la conexión e intenta nuevamente.'
            );
          } else if (!isOffline) {
            console.warn('No se pudo revalidar el perfil del usuario', error);
          }

          return false;
        }
      })();

      serverValidation = { uid: firebaseUser.uid, promise };
      promise.finally(() => {
        if (serverValidation?.promise === promise) serverValidation = null;
      });
      return promise;
    };

    const handleAuthState = async (firebaseUser) => {
      if (cancelled) return;

      if (!firebaseUser) {
        setLoggedInUser(null);
        setAuthInitializing(false);
        return;
      }

      setAuthInitializing(true);
      setAuthError('');

      const userRef = doc(db, 'users', firebaseUser.uid);
      let cachedProfile = null;

      try {
        const cachedSnapshot = await getDocFromCache(userRef);
        if (cachedSnapshot.exists()) cachedProfile = cachedSnapshot.data();
      } catch (_) {
        // Es normal en el primer ingreso de un dispositivo.
      }

      if (!isCurrentAuthUser(firebaseUser)) return;

      if (cachedProfile) {
        if (cachedProfile.isActive === false) {
          await rejectSession(
            'Tu usuario está desactivado. Consulta con el administrador.'
          );
          return;
        }

        applyProfile(firebaseUser, cachedProfile);
        if (!cancelled) setAuthInitializing(false);

        const isOnline =
          typeof navigator === 'undefined' || navigator.onLine !== false;
        if (isOnline) void validateFromServer(firebaseUser);
        return;
      }

      await validateFromServer(firebaseUser, { required: true });
    };

    const handleOnline = () => {
      const firebaseUser = auth.currentUser;
      if (firebaseUser) void validateFromServer(firebaseUser);
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('online', handleOnline);
    }

    authPersistenceReady.then(() => {
      if (!cancelled) {
        unsubscribe = onAuthStateChanged(auth, handleAuthState);
      }
    });

    return () => {
      cancelled = true;
      unsubscribe();
      if (typeof window !== 'undefined') {
        window.removeEventListener('online', handleOnline);
      }
    };
  }, []);

  if (authInitializing) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
        <div className="flex flex-col items-center gap-4 rounded-2xl border border-slate-200 bg-white px-8 py-7 shadow-sm">
          <div
            className="h-10 w-10 animate-spin rounded-full border-2 border-[#ff2ba6] border-t-transparent"
            role="status"
            aria-label="Validando sesión"
          />
          <div className="text-center">
            <p className="text-sm font-semibold text-slate-800">Validando sesión</p>
            <p className="mt-1 text-xs text-slate-500">
              Comprobando el acceso de este dispositivo...
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (

    <SettingsProvider>

      <ProductsProvider>

        <OfflineSyncProvider currentUser={loggedInUser}>

        <EntradasProvider currentUser={loggedInUser}>

          <AppInner
            loggedInUser={loggedInUser}
            authError={authError}
            clearAuthError={() => setAuthError('')}
          />

          <ToastContainer

            position="top-center"

            autoClose={2200}

            hideProgressBar={false}

            newestOnTop

            closeOnClick

            pauseOnFocusLoss

            draggable

            pauseOnHover

            theme="colored"

          />

        </EntradasProvider>

        </OfflineSyncProvider>

      </ProductsProvider>

    </SettingsProvider>

  );

}





// DONE










